import FlowUserFavoritesAPI from '../api/flowUserFavorites';

const state = {
  favorites: [],
  uiFlags: {
    isFetching: false,
    isToggling: false,
  },
};

const getters = {
  getFavorites: s => s.favorites,
  getFavoriteFlowIds: s => s.favorites.map(f => f.flow_id),
  isFlowFavorite: s => flowId => s.favorites.some(f => f.flow_id === flowId),
  getUIFlags: s => s.uiFlags,
};

const actions = {
  fetch: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await FlowUserFavoritesAPI.index();
      commit('SET_FAVORITES', response.data.data ?? []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  add: async ({ commit }, flowId) => {
    commit('SET_UI_FLAG', { isToggling: true });
    try {
      const response = await FlowUserFavoritesAPI.create(flowId);
      commit('ADD_FAVORITE', response.data.data);
    } finally {
      commit('SET_UI_FLAG', { isToggling: false });
    }
  },

  remove: async ({ commit }, flowId) => {
    commit('SET_UI_FLAG', { isToggling: true });
    try {
      await FlowUserFavoritesAPI.destroy(flowId);
      commit('REMOVE_FAVORITE', flowId);
    } finally {
      commit('SET_UI_FLAG', { isToggling: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG: (s, flags) => {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
  SET_FAVORITES: (s, favorites) => {
    s.favorites = favorites;
  },
  ADD_FAVORITE: (s, favorite) => {
    s.favorites.push(favorite);
  },
  REMOVE_FAVORITE: (s, flowId) => {
    s.favorites = s.favorites.filter(f => f.flow_id !== flowId);
  },
};

export default { namespaced: true, state, getters, actions, mutations };
